import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @param {object} props
 * @param {import('utils/types').BorderVariant} [props.variant='solid']
 * @param {import('utils/types').Orientation} [props.orientation='horizontal']
 * @param {string} [props.className='']
 */
export default function LineSeparator({
  variant = 'solid',
  orientation = 'horizontal',
  className = ''
}) {
  return (
    <div
      data-variant={variant}
      data-orientation={orientation}
      className={cn(styles.container, className)}
    />
  );
}
